<div class="content-main">
  @if (fg) {
    <form [formGroup]="fg" (submit)="update()">
      <mat-slide-toggle formControlName="active" class="toggle-icon">
        Override Global<br />
        Daily Deposit Limit
      </mat-slide-toggle>
      @if (fg.get('active').value) {
        <div>
          <app-money-v2 formControlName="value"></app-money-v2>
          <table>
            <tr>
              <td>
                <input type="checkbox" id="freeze" formControlName="freeze" />
                <label for="freeze">Freeze</label>
              </td>
              <td>
                <input type="checkbox" id="deposit-block" formControlName="depositBlock" />
                <label for="deposit-block">Deposit Block</label>
              </td>
            </tr>
          </table>
        </div>
      }
      <div class="progress-container">
        @if (editMode) {
          @if (updatingInProgress) {
            <mat-spinner class="progress-spinner" [diameter]="20"></mat-spinner>
          }
          @if (!success && !updatingInProgress) {
            <button mat-stroked-button color="primary" type="submit">Save</button>
          }
          @if (!success && !updatingInProgress) {
            <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
              <mat-icon>cancel</mat-icon>
            </button>
          }
        }
        @if (!editMode) {
          @if (!success) {
            <button mat-icon-button color="primary" type="submit" (click)="toggleEditMode()">
              <mat-icon>edit</mat-icon>
            </button>
          }
          @if (success) {
            <strong class="green">Changes saved</strong>
          }
        }
      </div>
    </form>
  }
</div>
